// extracted by mini-css-extract-plugin
module.exports = {"more":"styles_more__3q6XY","effect":"styles_effect__2Ir-Z"};